export default {"src":"/_next/static/media/fruit.41ecf8aa.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};